// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__OQuA1","colMin":"styles_colMin__1UtDr","colCheckbox":"styles_colCheckbox__1Asd_"};